<div class="div-arriere-plan-action" (click)="onDismiss(true)"></div>
<div class="div-global-action" (click)="$event.stopPropagation()">
  <div id="center-square">
    <div style="display: flex; justify-content: space-between; flex-direction: column; height: 100%">
      <div class="p-20 text-center" style="border-bottom: solid 1px #E3F2FF;">
        <img class="close-icon" src="assets/close_cross_black.svg" (click)="onDismiss(true)">
        <h3 class="bold header_title dark-blue">Supprimer l'utilisateur ?</h3>
      </div>

      <div class="p-20">
        <p class="dark-blue no-margin mb-10 bold">Êtes-vous sûr de vouloir supprimer
          <span class="light-blue normal">{{contactToDelete}}</span> ?</p>
      </div>

      <div class="p-20">
        <p class="grey text-xs flex gap-20 no-margin">
          <img src="assets/warning.svg" alt="warning icon" width="20px">
          L'utilisateur supprimé ne pourra plus accéder à l'application.
        </p>
      </div>

      <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 20px;" class="p-20">
        <v8te-active-button [buttonText]="'Annuler'" [primaryColor]="'#FFFFFF'" [textPrimaryColor]="'#2B2D67'"
          [border]="'solid 1px #D9D9D9'" [active]="true" (click)="onDismiss(true)" [height]="50" [minWidth]="190"
          [widthPercent]="100" [bold]="true"></v8te-active-button>

        <v8te-active-button [buttonText]="'Supprimer l\'utilisateur'" [primaryColor]="'#EF4444'"
          [textPrimaryColor]="'#FFFFFF'" (click)="onDeleteEvent()" [height]="50" [minWidth]="190" 
          [widthPercent]="100" [bold]="false" [border]="'none'"></v8te-active-button>
      </div>
    </div>
  </div>
</div>